import {addToCartHandler} from "./addToCart";
import Swiper from "swiper";
import {Thumbs, Controller} from 'swiper/modules';
import app from "../_app"
import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video";
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnails from "lightgallery/plugins/thumbnail";

const product = document.querySelector('.js-product');

if (product) {
    const forms = [...product.querySelectorAll('.js-product-form')];

    forms.map(form => {
        form?.addEventListener('submit', addToCartHandler);

        /**
         * Quantity select
         * @type {Element}
         */
        const orderSelect = form.querySelector('.js-order-select');
        const orderInput = form.querySelector('.js-order-input');

        if (orderSelect && orderInput) {
            orderSelect.addEventListener('change', () => {
                if (orderSelect.value === 'more') {
                    orderInput.classList.remove('d-none');
                    orderInput.setAttribute('name', 'quantity');
                    orderInput.setAttribute('required', '');

                    orderSelect.parentElement.remove();
                }
            })
        }
    })


    /**
     * Product images
     * @type {Swiper}
     */
    let $lgSwiper = document.getElementById('lg-swiper');

    let direction = 'horizontal';
    if (app.viewport.isEqualOrGreaterThan('lg')) {
        direction = 'horizontal';
    }

    const thumbs = new Swiper('.js-product-images-thumbs', {
        spaceBetween: 4,
        slidesPerView: 'auto',
        direction: direction,
        freeMode: true,
        watchSlidesProgress: true,
    });


    const mainImages = new Swiper('.js-product-images-main', {
        spaceBetween: 4,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        thumbs: {
            swiper: thumbs,
        },

        on: {
            init: function () {

                if (app.viewport.isEqualOrGreaterThan('lg')) {
                    $lgSwiper.addEventListener('lgInit', (event) => {
                        const instance = event.detail.instance;
                        const lgOuter = instance.lgOpened ? instance.lgOpened : document.querySelector('.lg-outer');
                        const customContent = document.getElementById('add-to-cart-fixed').innerHTML;
                        const wrapper = document.createElement('div');
                        wrapper.innerHTML = customContent;
                        wrapper.classList.add('lg-add-to-cart');
                        lgOuter.appendChild(wrapper);
                    });
                }

                const lg = lightGallery($lgSwiper, {
                    closable: true,
                    showCloseIcon: true,
                    plugins: [lgVideo, lgZoom, lgThumbnails],
                    licenseKey: '36E69817-E4B8-4397-A896-94F904EE212D',
                    download: false,
                    zoom: false,
                    videojs: true,
                    mobileSettings: {
                        showCloseIcon: true
                    }
                });

                $lgSwiper.classList.remove('d-none');
            },
        }
    });

    document.querySelectorAll('.js-pdp-fixed').forEach($fixed => {
        if (app.viewport.isSmallerThan('md')) {
            const $order = document.querySelector('.js-pdp-order');
            const $submitButton = document.querySelector('.js-product-form');

            if ($order) {
                const scrollTop = $order.offsetTop + $order.offsetHeight;

                window.addEventListener('scroll', () => {
                    if (window.scrollY >= scrollTop) {
                        $fixed.classList.add('active');
                    } else {
                        $fixed.classList.remove('active');
                    }

                    const buttonRect = $submitButton.getBoundingClientRect();

                    // Check if button is in viewport
                    const isInView = (
                        buttonRect.top >= 0 &&
                        buttonRect.left >= 0 &&
                        buttonRect.bottom <= (window.innerHeight + 50) &&
                        buttonRect.right <= window.innerWidth
                    );

                    // Toggle class based on visibility
                    if (isInView) {
                        $fixed.classList.add('hide');
                    } else {
                        $fixed.classList.remove('hide');
                    }
                });
            }
        } else {
            const $order = document.querySelector('.js-pdp-order-desktop').querySelector('.js-order-button');

            if ($order) {
                let scrollTop = 0;

                window.addEventListener('scroll', () => {
                    scrollTop = $order.getBoundingClientRect().top + $order.offsetHeight;

                    if (scrollTop < 0) {
                        $fixed.classList.add('active');
                    } else {
                        $fixed.classList.remove('active');
                    }
                });
            }
        }
    });
}
